import { render, staticRenderFns } from "./SupplierBrandSelect_1.vue?vue&type=template&id=46dddd83&scoped=true&"
import script from "./SupplierBrandSelect_1.vue?vue&type=script&lang=js&"
export * from "./SupplierBrandSelect_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dddd83",
  null
  
)

export default component.exports